<script>
import Vue from "vue";
import {
  RichTextEditorPlugin,
  Toolbar,
  Link,
  Image,
  Count,
  HtmlEditor,
  QuickToolbar,
  Table,
} from "@syncfusion/ej2-vue-richtexteditor";
Vue.use(RichTextEditorPlugin);

export default {
  name: "ChiefComplains",

  data() {
    return {
      showAdd: false,
      chiefComplains: [],
      templates: [],
      templateID: 0,
      chiefComplain: {
        complaint: `-`,
        duration: `-`,
        complaintId: 0,
        encounterId: this.$route.params.encounterID,
        patientID: this.$route.params.patientID,
        visitNo: this.$route.params.visitNO,
        userName: this.$root.username,
        description: ``,
      },
    };
  },

  watch: {
    templateID() {
      if (!this.templateID) return;

      const templates = this.templates.filter(
        (temp) => temp.tempID == this.templateID
      );

      if (!templates.length) return;

      this.chiefComplain.description = templates[0].template;
    },

    "$route.params.encounterID"() {
      this.fetchMFChiefComplains();
    },
  },

  provide: {
    richtexteditor: [
      Toolbar,
      Link,
      Image,
      Count,
      HtmlEditor,
      QuickToolbar,
      Table,
    ],
  },

  mounted() {
    Promise.all([this.fetchMFChiefComplains(), this.fetchTemplates()]);
  },

  methods: {
    fetchTemplates() {
      return this.$http
        .get(`MedicalFile/GetMedicalNotesTemplateNames`)
        .then((response) => {
          this.templates = response.data;
        })
        .catch(() => {});
    },

    fetchMFChiefComplains() {
      if (!this.$route.params.encounterID) return Promise.reject();

      let url = `MedicalFile/GetPtMedicalFileChiefComplainsForEncounter`;
      url += `?PatientID=${this.$route.params.patientID}`;
      url += `&VisitNo=${this.$route.params.visitNO}`;
      url += `&EncounterID=${this.$route.params.encounterID}`;

      return this.$http
        .get(url)
        .then(({ data }) => {
          this.chiefComplain = data.length
            ? data[0]
            : {
                complaint: `-`,
                duration: `-`,
                complaintId: 0,
                encounterId: this.$route.params.encounterID,
                patientID: this.$route.params.patientID,
                visitNo: this.$route.params.visitNO,
                userName: this.$root.username,
                description: ``,
              };
        })
        .catch(() => {});
    },

    saveData() {
      this.$root.loading = true;
      this.$http
        .post(`MedicalFile/MedicalFileChiefComplains`, this.chiefComplain)
        .then(() => {
          this.fetchMFChiefComplains();
          this.$root.loading = false;
        })
        .catch(() => {
          this.$root.loading = false;
        });
    },
  },
};
</script>
<template>
  <div class="w-full flex flex-wrap mt-px">
    <div class="w-full flex flex-col p-tiny">
      <div class="w-full md:w-4/5 p-tiny">
        <label for="grid-template" class="label-control">Template</label>
        <v-select
          class="text-xs bg-white"
          :options="templates"
          :reduce="(temp) => temp.tempID"
          v-model="templateID"
          label="tempName"
        ></v-select>
      </div>
      <div class="flex-1 p-tiny">
        <label for="grid-complaint-notes" class="label-control">Notes:</label>
        <ejs-richtexteditor
          ref="historyOfIllnessRTE"
          v-model.trim="chiefComplain.description"
          :height="230"
          :disabled="
            ($root.formatLowercase(chiefComplain.userName) ==
              $root.formatLowercase($root.username)) ||
            $root.checkAuth('AdminEditMedicalFile') ? false : true
          "
          :insertImageSettings="{ saveFormat: 'Base64' }"
          :toolbarSettings="{
            items: [
              'Bold',
              'Italic',
              'Underline',
              'StrikeThrough',
              'FontName',
              'FontSize',
              'FontColor',
              'BackgroundColor',
              'LowerCase',
              'UpperCase',
              'SuperScript',
              'SubScript',
              '|',
              'Formats',
              'Alignments',
              'OrderedList',
              'UnorderedList',
              'Outdent',
              'Indent',
              '|',
              'CreateTable',
              'CreateLink',
              'Image',
              '|',
              'ClearFormat',
              'Print',
              'SourceCode',
              'FullScreen',
              '|',
              'Undo',
              'Redo',
            ],
          }"
        />
      </div>
      <div class="flex-1 p-tiny text-right">
        <button
          v-if="
            $root.formatLowercase(chiefComplain.userName) ==
              $root.formatLowercase($root.username) ||
            $root.checkAuth('AdminEditMedicalFile')
          "
          @click.prevent="saveData"
          class="btn-primary btn-sm text-sm rounded"
        >
          <i class="fa fa-save"></i> Save
        </button>
      </div>
    </div>
  </div>
</template>
